import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
// slices
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import locationReducer from './slices/location';
import userReducer from './slices/user';
import resourceReducer from './slices/resource';
import companyReducer from './slices/company';
import tagReducer from './slices/tag';
import documentReducer from './slices/document';
import live_positionReducer from './slices/live_position';
import catalogReducer from './slices/catalog';
import assetReducer from './slices/assets';
import fleetReducer from './slices/fleet';
import toolkitReducer from './slices/toolkit';
import equipmentReducer from './slices/equipment';
import job_costReducer from './slices/job_cost';
import job_masterReducer from './slices/job_master';
import jobStatusReducer from './slices/job';
import liveTrackingReducer from './slices/liveTracking';
import ticketReducer from './slices/ticket';
import blockingLoaderReducer from './slices/blockingLoader';
import catalogApiReducer from './slices/api/catalog';
import planApiReducer from './slices/api/plan';
import skillsReducer from './slices/skill';
import menuReducer from './slices/menu';
import attachmentReducer from './slices/attachment';
import blogReducer from './slices/blog'

// ----------------------------------------------------------------------

const createNoopStorage = () => ({
  getItem() {
    return Promise.resolve(null);
  },
  setItem(_key, value) {
    return Promise.resolve(value);
  },
  removeItem() {
    return Promise.resolve();
  },
});

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage();

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  calendar: calendarReducer,
  blockingLoader: blockingLoaderReducer,
  kanban: kanbanReducer,
  location: persistReducer(
    {
      key: 'location',
      storage,
      keyPrefix: 'redux-',
      whitelist: ['country_id', 'state_id', 'city_id', 'countries', 'states', 'cities', 'locationstatuses', 'taxcodes'],
    },
    locationReducer
  ),
  user: persistReducer(
    {
      key: 'user',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    userReducer
  ),
  resource: persistReducer(
    {
      key: 'resource',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    resourceReducer
  ),
  company: persistReducer(
    {
      key: 'company',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    companyReducer
  ),
  tag: persistReducer(
    {
      key: 'tag',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    tagReducer
  ),

  document: persistReducer(
    {
      key: 'document',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    documentReducer
  ),

  live_position: persistReducer(
    {
      key: 'live_position',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    live_positionReducer
  ),

  catalog: persistReducer(
    {
      key: 'catalog',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    catalogReducer
  ),
  catalogApi: persistReducer(
    {
      key: 'catalogApi',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    catalogApiReducer
  ),
  planApi: persistReducer(
    {
      key: 'planApi',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    planApiReducer
  ),
  menu: persistReducer(
    {
      key: 'menu',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    menuReducer
  ),
  asset: persistReducer(
    {
      key: 'asset',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    assetReducer
  ),
  fleet: persistReducer(
    {
      key: 'fleet',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    fleetReducer
  ),
  toolkit: persistReducer(
    {
      key: 'toolkit',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    toolkitReducer
  ),
  job_cost: persistReducer(
    {
      key: 'job_cost',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    job_costReducer
  ),
  job_master: persistReducer(
    {
      key: 'job_master',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    job_masterReducer
  ),
  job: persistReducer(
    {
      key: 'job',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    jobStatusReducer
  ),
  equipment: persistReducer(
    {
      key: 'equipment',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    equipmentReducer
  ),

  liveTracking: persistReducer(
    {
      key: 'liveTracking',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    liveTrackingReducer
  ),

  ticket: persistReducer(
    {
      key: 'ticket',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    ticketReducer
  ),

  skill: persistReducer(
    {
      key: 'skill',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    skillsReducer
  ),

  attachment: persistReducer(
    {
      key: 'attachment',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    attachmentReducer
  ),

  blog: persistReducer(
    {
      key: 'blog',
      storage,
      keyPrefix: 'redux-',
      whitelist: [],
    },
    blogReducer
  ),
});

export { rootPersistConfig, rootReducer };
